import { Button, Form, Tooltip } from "antd";
import React from "react";
import { CopyOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { ZUid } from "src/types/zUid";
import { CurrentNodePort } from "src/pages/ManagementPage/objects/ports";
import { edAttrField } from "../../EdAttribute";
import { EdObjStates } from "../../EdObject";
import { ZPermissions } from "../roleTypes";
import { createCopyOnRoleMap } from "./createCopyOnRoleMap";

interface PropsCopyOnRoleButton {
  stateId: ZUid;
  roleName: string;
  groupId: ZUid;
  roleId: ZUid;
  store: CurrentNodePort;
}

export const CopyOnRoleButton: React.FC<PropsCopyOnRoleButton> = observer(
  ({ stateId, roleName, roleId, groupId, store }) => {
    const form = Form.useFormInstance();
    const rolesMap: EdObjStates | undefined = Form.useWatch(
      edAttrField.rolesMap,
    );
    const curPermissonsItem: ZPermissions | undefined = Form.useWatch([
      edAttrField.rolesMap,
      String(stateId),
    ]);
    if (!rolesMap || !curPermissonsItem) return null;

    const copyOnRole = (curGroupId: ZUid, curRoleId: ZUid) => {
      const newValue = createCopyOnRoleMap({
        curGroupId,
        curRoleId,
        curPermissonsItem,
        rolesMap,
      });
      if (!newValue) return;
      form.setFieldValue(edAttrField.rolesMap, newValue);
      store.formStore.setFormStatus("changed");
    };

    return (
      <Tooltip
        title={`Скопировать на роль ${roleName} для всех состояний атрибута`}
      >
        <Button
          size="small"
          type="text"
          icon={<CopyOutlined />}
          onClick={() => copyOnRole(groupId, roleId)}
        />
      </Tooltip>
    );
  },
);
